import React, { useState } from 'react';
import type { Clase, Evaluacion, ResultadoEval } from '../../types';
import { Modal } from '../ui/Modal';
import { Boton } from '../ui/Boton';
import { CampoArea, CampoSelect } from '../ui/Campo';
const RESULTADOS: ResultadoEval[] = ['Todo', 'Parcial', 'Se modificó la propuesta'];
interface Props {
  clase: Clase | null;
  abierto: boolean;
  onCerrar: () => void;
  onGuardar: (evaluacion: Evaluacion) => void;
  onProximaClase: (evaluacion: Evaluacion) => void;
}
export function EvaluacionModal({
  clase,
  abierto,
  onCerrar,
  onGuardar,
  onProximaClase
}: Props) {
  const [datos, setDatos] = useState<Evaluacion>(clase?.evaluacion || {
    resultado: 'Todo',
    funciono: '',
    dificultad: '',
    adaptaciones: '',
    repetir: '',
    proximoObjetivo: '',
    observaciones: '',
    fecha: new Date().toISOString()
  });
  React.useEffect(() => {
    if (clase) {
      setDatos(clase.evaluacion || {
        resultado: 'Todo',
        funciono: '',
        dificultad: '',
        adaptaciones: '',
        repetir: '',
        proximoObjetivo: '',
        observaciones: '',
        fecha: new Date().toISOString()
      });
    }
  }, [clase]);
  if (!clase) return null;
  const cambiar = (parcial: Partial<Evaluacion>) => setDatos(prev => ({
    ...prev,
    ...parcial
  }));
  return <Modal abierto={abierto} titulo="Lo que pasó también planifica lo que sigue" descripcion={clase.titulo} onCerrar={onCerrar} acciones={<>
          <Boton variante="contorno" onClick={onCerrar} data-id="element-340" data-mp="248fehhduzuz4">
            Cancelar
          </Boton>
          <Boton variante="secundario" onClick={() => onProximaClase({
      ...datos,
      fecha: new Date().toISOString()
    })} data-id="element-341" data-mp="295xrbiuzyuce">
            Crear próxima clase desde esta
          </Boton>
          <Boton onClick={() => onGuardar({
      ...datos,
      fecha: new Date().toISOString()
    })} data-id="element-342" data-mp="1ghs5stw4d1bi">
            Guardar evaluación
          </Boton>
        </>} data-id="element-339" data-mp="2wuqofincv88l">
      <div className="space-y-4" data-id="element-343" data-mp="1dgp2d3qu87t6">
        <CampoSelect etiqueta="Resultado" value={datos.resultado} opciones={RESULTADOS} onChange={e => cambiar({
        resultado: e.target.value as ResultadoEval
      })} data-id="element-344" data-mp="1dfnoysmcn98a" />
        <CampoArea etiqueta="Qué funcionó bien" value={datos.funciono} onChange={e => cambiar({
        funciono: e.target.value
      })} data-id="element-345" data-mp="1n68ku8an1zni" />
        <CampoArea etiqueta="Qué presentó dificultad" value={datos.dificultad} onChange={e => cambiar({
        dificultad: e.target.value
      })} data-id="element-346" data-mp="uhb2k56fg2ur" />
        <CampoArea etiqueta="Adaptaciones utilizadas" value={datos.adaptaciones} onChange={e => cambiar({
        adaptaciones: e.target.value
      })} data-id="element-347" data-mp="14gaa1kfghsg6" />
        <CampoArea etiqueta="Qué conviene repetir" value={datos.repetir} onChange={e => cambiar({
        repetir: e.target.value
      })} data-id="element-348" data-mp="zjjy99aopj0k" />
        <CampoArea etiqueta="Próximo objetivo" value={datos.proximoObjetivo} ayuda="Aparece en Inicio como próximo objetivo." onChange={e => cambiar({
        proximoObjetivo: e.target.value
      })} data-id="element-349" data-mp="2avuigrbd46te" />
        <CampoArea etiqueta="Observaciones generales" value={datos.observaciones} onChange={e => cambiar({
        observaciones: e.target.value
      })} data-id="element-350" data-mp="29f6xq3epmeg0" />
      </div>
    </Modal>;
}